<!--components\Mapas\MapaBuscadorGeneral.vue-->
<template>
  <!-- Desktop Version -->
  <div id="popupLocales" class="hidden fixed top-0 left-0 w-full h-full bg-black bg-opacity-25 transition-all items-center justify-center z-[2100]">
    <div id="popup"
      class="flex flex-col bg-white p-3 pt-6 md:p-10 md:rounded-3xl w-full h-full md:max-w-[1200px] md:max-h-[700px] relative">
      <!-- Header -->
      <div id="closePopup" @click="closeTelephone" class="absolute top-2 right-2 md:top-5 md:right-5 bg-ROJO_LEON rounded-full py-2 px-1 cursor-pointer inline transition">
        <div class="bg-white h-1 w-4 rounded-full rotate-45 relative top-[2px]"></div>
        <div class="bg-white h-1 w-4 rounded-full -rotate-45 relative -top-[2px]"></div>
      </div>

      <div v-show="etapa_mobile == 1"
        class="flex items-center px-1 md:px-0 font-bold justify-center text-center leading-5 text-xs md:text-2xl md:mb-4">
        <div class="pb-4 pt-5 px-4 md:p-0">
          <h2 class="text-base md:text-xl">
            Para llamar a tu local más cercano, ingresa tu ubicación.
          </h2>
        </div>
      </div>

      <!-- Search Bar -->
      <div v-show="etapa_mobile == 1" class="flex gap-3 mb-4 px-2 md:px-0">
        <span>
          <img :src="'/img/imagenes-popup-locales/etiqueta.webp'" class="w-[30px] h-auto" />
        </span>
        <input ref="inputUbicacionRef" type="text" :disabled="!isRootRoute"
          class="z-[2101] text-sm bg-GRIS_INPUT w-full rounded-xl px-5 py-2 md:py-3 font-bold border-none" />
      </div>

      <!-- Main Content Area -->
      <div class="flex-1 flex md:grid md:grid-cols-2 flex-col gap-3 md:gap-3 min-h-0">
        <button v-show="etapa_mobile == 2" @click="retroceder_fase"
          class="py-2 px-3 border rounded-lg text-ROJO_LEON font-semibold w-[40%] border-ROJO_LEON transition hover:bg-ROJO_LEON hover:text-white group">
          <span
            class="border-b-2 border-r-2 inline-block p-1 rotate-[135deg] border-ROJO_LEON group-hover:border-white group-hover:-translate-x-1 transition duration-700"></span>
          volver
        </button>
        <!-- locales List -->
        <div v-show="etapa_mobile == 1" class="paso_1 flex flex-col h-full overflow-hidden">
          <h3 class="font-semibold text-center md:text-start leading-5 text-base md:text-lg mb-2 md:mb-2 px-3 md:p-0"
            :class="{
              'text-gray-500': gps_state === 2,
              'text-black': gps_state === 1,
            }">
            Acá te mostramos las sucursales más próximas a tu zona:
          </h3>

          <div class="contenedor_locales flex-1 overflow-y-auto">
            <!-- Store items will be rendered here -->
            <template v-if="locales_map && locales_map.length">

              <label @click="handleClick($event, store)" v-for="store in locales_map" :key="store.id"
                class="store-label flex justify-center items-center flex-col px-2 py-6 gap-4 md:gap-5 mt-0 mb-3 mr-1 md:mr-4 cursor-pointer bg-gray-100 rounded-lg border border-transparent transition-colors duration-200">

                <!-- tipo leon -->
                <div class="flex flex-col w-full h-auto gap-1 md:gap-1" v-if="store.tipo == 'leon'">

                  <div class="w-full flex flex-row justify-center items-center gap-3 h-36 md:h-56">
                    <input type="radio" name="store" :value="store.id" class="listado_locales sr-only" />

                    <!-- imagen grande del local -->
                    <img :src="store.tipo === 'leon'
                      ? '/img/imagenes-popup-locales/LeonVector.png'
                      : '/img/imagenes-popup-locales/AsociadosVector.png'
                      " class="w-[48%] md:w-[44%] h-[100%] md:h-[90%]" :alt="store.tipo === 'leon' ? 'Local León' : 'Tienda Asociada'
                        " />

                    <!-- Logo, nombre y -->
                    <div class="w-[40%] flex flex-col gap-2 justify-start">
                      <div class="flex flex-col gap-1">
                        <img :src="store.tipo === 'leon'
                          ? '/img/imagenes-popup-locales/logo/leon.webp'
                          : '/img/imagenes-popup-locales/logo/asociado.svg'
                          " class="h-auto w-[50%] self-start" />
                        <h3 class="leading-tight text-ROJO_TITULOS_LEON text-[22px] font-bold">
                          {{ store.name }}
                        </h3>
                        <p
                          :class="['text-sm font-bold', store.status === 'CERRADO' ? 'text-ROJO_LEON' : 'text-VERDE_DISPONIBLE']">
                          {{ store.status }}
                        </p>
                      </div>

                      <!-- Datos del local para desktop -->
                      <div class="hidden md:flex flex-row md:flex-col justify-left items-center md:items-start">
                        <div class="flex flex-row justify-left items-center gap-1">
                          <img src="/img/dc_img/location_on.svg" class="w-4 h-4" />
                          <p class="text-sm font-bold">
                            {{ store.textLocation }}
                          </p>
                        </div>
                        <div class="flex flex-row justify-left items-center gap-1">
                          <img src="/img/dc_img/schedule.svg" class="w-4 h-4" />
                          <p class="text-sm font-bold">{{ store.schedule[0] }}</p>
                        </div>
                        <div class="flex flex-row justify-left items-center gap-1">
                          <img src="/img/dc_img/schedule.svg" class="w-4 h-4" />
                          <p class="text-sm font-bold">{{ store.schedule[1] }}</p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Datos del local para mobile -->
                  <div
                    class="flex md:hidden flex-col md:flex-row justify-left items-left md:items-center gap-2 pl-[1rem]">
                    <div class="flex flex-row justify-left items-center gap-1">
                      <img src="/img/dc_img/location_on.svg" class="w-4 h-4" />
                      <p class="text-sm font-bold">{{ store.textLocation }}</p>
                    </div>
                    <div class="flex flex-row justify-left items-center gap-1">
                      <img src="/img/dc_img/schedule.svg" class="w-4 h-4" />
                      <p class="text-sm font-bold">{{ store.schedule[0] }}</p>
                    </div>
                    <div class="flex flex-row justify-left items-center gap-1">
                      <img src="/img/dc_img/schedule.svg" class="w-4 h-4" />
                      <p class="text-sm font-bold">{{ store.schedule[1] }}</p>
                    </div>
                  </div>

                  <!-- BOTONES -->
                  <div class="flex w-full justify-center gap-2 md:gap-4 items-center pt-4">
                    <button type="button" :value="store.id"
                      :class="`bg-white btn_como_llegar ${store.id} 
                      btn_modal_como_llegar btn_modal_como_llegar_${store.name.toLowerCase().replace(/\s/g,'')} 
                      text-ROJO_LEON border text-sm font-bold border-ROJO_LEON rounded-md py-2 px-2 md:px-3 w-[46%] md:w-[38%] 
                      flex items-center justify-center md:justify-center`"
                    >
                      <img src="/img/checkout-images/icono-como-llegar-rojo.webp" alt="icono-como-llegar" class="mr-2 h-5" />
                      ¿Cómo llegar?
                    </button>

                    <button type="button"
                      :class="`btn_number btn_modal_llamada btn_modal_llamada_${store.name.toLowerCase().replace(/\s/g,'')} 
                      bg-VERDE_TOP_CALIDAD border text-sm font-bold rounded-md py-2 px-2 md:px-3 w-[46%] md:w-[38%] text-white 
                      flex items-center justify-center md:justify-center`"
                    >
                      <img src="/img/dc_img/telefonito.svg" alt="icono-como-llegar" class="mr-2 h-5" />
                      <a :href="`tel:${store.telephone}`" style="text-decoration: none; color: #ffffff">
                        {{ formatNumberPhone(store.telephone) }}
                      </a>
                    </button>
                  </div>
                </div>

                <!-- tipo asociado -->
                <div class="flex flex-col w-full h-auto gap-1 md:gap-0" v-if="store.tipo == 'asociado'">

                  <div class="w-full flex flex-row justify-center items-center gap-3 h-36 md:h-56">
                    <input type="radio" name="store" :value="store.id" class="listado_locales sr-only" />

                    <!-- imagen grande del local -->
                    <img
                      :src="store.tipo === 'leon' ? '/img/imagenes-popup-locales/LeonVector.png' : '/img/imagenes-popup-locales/AsociadosVector.png'"
                      class="w-[48%] md:w-[44%] h-[100%] md:h-[90%]"
                      :alt="store.tipo === 'leon' ? 'Local León' : 'Tienda Asociada'" />

                    <div class="flex flex-col w-[40%] gap-3">
                      <!-- Logo, nombre y -->
                      <div class="flex w-full flex-col justify-start">
                        <div class="flex flex-col gap-1">
                          <img :src="store.tipo === 'leon'
                            ? '/img/imagenes-popup-locales/logo/leon.webp'
                            : '/img/imagenes-popup-locales/logo/vector-logo-nuevo.svg'
                            " class="h-auto w-[50%] self-start" />
                          <h3 class="pt-1 leading-[1] text-ROJO_TITULOS_LEON text-[22px] font-bold">
                            {{ store.comuna_nombre }}
                          </h3>
                          <p class="leading-[1] text-black text-[22px] font-bold">
                            Asociado
                          </p>
                        </div>
                      </div>

                      <!-- BOTONES -->
                      <div class="flex w-full justify-center gap-2 md:gap-4 items-center">
                        <!--original
                        <button type="button"
                          class="bg-VERDE_TOP_CALIDAD border text-sm font-bold rounded-md py-2 px-2 md:px-3 w-full text-white flex items-center justify-center md:justify-center"
                          :class="`btn_number btn_modal_llamada btn_modal_llamada_${store.name.toLowerCase().replace(/\s/g, '')}`">
                          <img src="/img/dc_img/telefonito.svg" alt="icono-como-llegar" class="mr-2 h-5" />
                          <a :href="`tel:${store.telephone}`" style="text-decoration: none; color: #ffffff">
                            {{ formatNumberPhone(store.telephone) }}
                          </a>
                        </button>
                        -->
                        <button type="button" id="btn-whatsapp" @click="abrirWhatsapp(store.telephone)"
                          :class="`btn_number btn_modal_llamada btn_modal_llamada_${store.name.toLowerCase().replace(/\s/g, '')}
                          bg-VERDE_TOP_CALIDAD border text-sm font-bold rounded-md py-2 px-2 md:px-3 w-full text-white flex items-center justify-center md:justify-center`"
                        >
                          <img src="/img/home/wsp.png" alt="WhatsApp" class="mr-2 h-5" />
                          <span style="text-decoration: none; color: #ffffff">
                            {{ formatNumberPhone(store.telephone) }}
                          </span>
                        </button>
                      </div>
                    </div>

                  </div>
                </div>

              </label>

            </template>
            <template v-else>
              <p class="text-center text-gray-500 mt-4">
                No hay locales disponibles
              </p>
            </template>
          </div>
        </div>

        <div v-show="etapa_mobile == 2" class="paso_2 flex flex-col h-auto w-full overflow-hidden">
          <div class="flex flex-row w-full bg-gray-100 gap-2 rounded-md px-6 py-2 justify-evenly items-center">
            <!-- imagen grande del local -->
            <img :src="localSeleccionado.tipo === 'leon'
              ? '/img/imagenes-popup-locales/LeonVector.png'
              : '/img/imagenes-popup-locales/AsociadosVector.png'
              " class="w-[48%] md:w-[44%] h-[100%] md:h-[90%]" :alt="localSeleccionado.tipo === 'leon'
                ? 'Local León'
                : 'Tienda Asociada'
                " />
            <!-- Logo, nombre y  -->
            <div class="flex flex-col gap-3 justify-start">
              <div class="flex flex-col gap-1">
                <img :src="localSeleccionado.tipo === 'leon'
                  ? '/img/imagenes-popup-locales/logo/leon.webp'
                  : '/img/imagenes-popup-locales/logo/vector-logo-nuevo.svg'
                  " class="h-auto w-[50%] self-start" />
                <h3 class="leading-tight text-ROJO_TITULOS_LEON text-[22px] font-bold">
                  {{ localSeleccionado.comuna_nombre }}
                </h3>
                <p class="leading-[1] text-black text-[22px] font-bold">
                  Asociado
                </p>
              </div>
            </div>
          </div>
        </div>

        <!-- Mapa -->
        <div :class="[etapa_mobile == 1 ? 'hidden' : 'flex']" id="map"
          class="w-full h-[50%] md:h-full md:min-h-[300px] md:flex"></div>

        <!-- Navigation Buttons -->
        <div v-show="etapa_mobile == 2" class="flex w-full flex-col justify-end items-center gap-4 flex-none">
          <a :href="getWazeUrl(localSeleccionado)" target="_blank"
            class="flex w-[80%] bg-white text-black text-sm font-bold rounded-md py-2 px-3 items-center justify-center border border-gray-200 hover:bg-gray-50">
            <img src="/img/dc_img/waze.svg" alt="waze" class="mr-2 h-5 w-5" />
            Abrir con Waze
          </a>
          <a :href="getGoogleMapsUrl(localSeleccionado)" target="_blank"
            class="flex w-[80%] bg-white text-black text-sm font-bold rounded-md py-2 px-3 items-center justify-center border border-gray-200 hover:bg-gray-50">
            <img src="/img/dc_img/gmap.svg" alt="google-maps" class="mr-2 h-5 w-5" />
            Abrir con Google Maps
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import useMapaBuscadorGeneral from "@/composables/useMapaBuscadorGeneral";
import useGoogleServices from "~/composables/useGoogleServices";
import useUbicacionUsuario from "~/composables/useUbicacionUsuario";
import { ref, onMounted, computed, watch } from "vue";
import { useRoute } from "vue-router";
import { NEGOCIOS } from "~/constants/negocios";
import { verificarSincronizacion } from '@/composables/useModoSistema';
/*
  DC: SI SE MODIFICA EL ESTILO RECORDAR DEJAR CLASE btn_modal_como_llegar 
  DC: SI SE CAMBIA EL FLUJO RECORDAR PASAR CLASE btn_modal_como_llegar
  DC: SI SE MODIFICA EL ESTILO RECORDAR DEJAR CLASE btn_modal_llamada 
  DC: SI SE CAMBIA EL FLUJO RECORDAR PASAR CLASE btn_modal_llamada
*/

// Acceder al estado global SIN crear nueva instancia
const modo_sistema = useState('modo_sistema');

const config = useRuntimeConfig();

const debug = {
  enabled: config.public.modo === 'DEV',

  log(...args) {
    if (this.enabled) console.log(...args);
  },
  error(...args) {
    if (this.enabled) console.error(...args);
  },
};

const route = useRoute();
const { formatNumberPhone } = UseUtilities();
const { generarRuta, funcion_de_inicio, locales_map, gps_state } = useMapaBuscadorGeneral();
const { ubication } = useCartBridge();
const { seleccionarUbicacion } = useUbicacionUsuario();
const { crearAutocomplete } = useGoogleServices('MapaBuscadorGeneral');
const { configurarInput } = crearAutocomplete({ alSeleccionar: seleccionarUbicacion });
const inputUbicacionRef = ref(null);
const localSeleccionado = ref([]);
const etapa_mobile = ref(1);

const isRootRoute = computed(() => {
  return (  
    modo_sistema.value === NEGOCIOS.HOME 
    || route.path === `/${NEGOCIOS.NEUMATICOS}` 
    || route.path === `/${NEGOCIOS.BATERIAS}` 
    || route.path === `/${NEGOCIOS.ACEITES}` 
    || route.path === `/${NEGOCIOS.FRENOS}`
    || route.path === `/${NEGOCIOS.AFINAMIENTO}`
    || route.path === `/${NEGOCIOS.AMORTIGUADORES}`
    || route.path === `/${NEGOCIOS.TRENDELANTERO}`
    || route.path === `/${NEGOCIOS.BALANCEO}`
    || route.path === `/${NEGOCIOS.GEOMETRIA}`
    || route.path === `/${NEGOCIOS.KILOMETRAJE}`
    || route.path === `/${NEGOCIOS.HIGIENIZACION}`
    || route.path === `/${NEGOCIOS.FLUIDOS}`
    || route.path === `/${NEGOCIOS.ALINEACION}`
    || route.path === `/${NEGOCIOS.ELECTRICO}`
    || route.path === `/${NEGOCIOS.ACCESORIOS}`
  );
});

const getWazeUrl = (store) => {
  if (!store || !store.mapLocation) {
    return "";
  }
  return `https://waze.com/ul?ll=${store.mapLocation.lat},${store.mapLocation.lng}&navigate=yes`;
};

const getGoogleMapsUrl = (store) => {
  if (!store || !store.mapLocation) {
    return "";
  }
  return `https://www.google.com/maps/dir/?api=1&destination=${store.mapLocation.lat},${store.mapLocation.lng}`;
};

const handleClick = (e, store) => {
  if (e.target.closest(".btn_number") || e.target.closest('a[href^="tel:"]')) {
    return;
  }

  document.querySelectorAll(".store-label").forEach((l) =>
    l.classList.remove("borde_especial")
  )

  e.target.closest(".store-label").classList.add("borde_especial");

  localSeleccionado.value = store;

  // MODIFICAR ESTA PARTE:
  if (window.innerWidth < 768 && store.tipo === 'leon') {
    etapa_mobile.value = 2;
  }

  generarRuta(store);
};

const retroceder_fase = () => {
  etapa_mobile.value = 1;
};

const closeTelephone = () => {
  const popupLocales = document.getElementById("popupLocales");
  etapa_mobile.value = 1;
  if (popupLocales) {
    popupLocales.classList.add("hidden");
  }

  document.body.style.overflow = "auto";
};

const abrirWhatsapp = (numero_whatsapp) => {
  let mensaje = 'Hola, necesito orientación sobre un producto que encontré en la web de LEÓN Servicio Automotriz. ¿Podría un ejecutivo asesorarme?'
  
  if (route.path.startsWith('/neumaticos')) {
    mensaje = 'Hola, necesito orientación sobre neumáticos que encontré en la web de LEÓN Servicio Automotriz. ¿Podría un ejecutivo asesorarme?'
  } else if (['/aceites', '/cambio-de-aceite'].includes(route.path)) {
    mensaje = 'Hola, necesito orientación sobre aceites que encontré en la web de LEÓN Servicio Automotriz. ¿Podría un ejecutivo asesorarme?'
  } else if (route.path === '/frenos') {
    mensaje = 'Hola, necesito orientación sobre agendamiento de frenos que encontré en la web de LEÓN Servicio Automotriz. ¿Podría un ejecutivo asesorarme?'
  } else if (route.path === '/baterias') {
    mensaje = 'Hola, necesito orientación sobre baterías que encontré en la web de LEÓN Servicio Automotriz. ¿Podría un ejecutivo asesorarme?'
  } else if (['/afinamiento', '/afinamiento-motor'].includes(route.path)) {
    mensaje = 'Hola, quisiera revisar afinamiento...';
  } else if (route.path == '/amortiguadores' ) {
      mensaje = 'Hola, quisiera revisar amortiguadores...';
  } else if (['/trendelantero', '/tren-delantero'].includes(route.path)) {
      mensaje = 'Hola, quisiera revisar tren delantero...';
  } else if (route.path == '/balanceo' ) {
      mensaje = 'Hola, quisiera revisar balanceo...';
  } else if (['/geometria', '/geometria-automotriz'].includes(route.path)) {
      mensaje = 'Hola, quisiera revisar geometria...';
  } else if (['/kilometraje', '/mantencion-kilometraje'].includes(route.path)) {
      mensaje = 'Hola, quisiera revisar kilometraje...';
  } else if (route.path == '/higienizacion' ) {
      mensaje = 'Hola, quisiera revisar higienizacion...';
  } else if (route.path == '/fluidos' ) {
      mensaje = 'Hola, quisiera revisar fluidos...';
  } else if (route.path == '/alineacion' ) {
      mensaje = 'Hola, quisiera revisar alineacion...';
  } else if (['/electrico', '/electrico-automotriz'].includes(route.path)) {
      mensaje = 'Hola, quisiera revisar electrico...';
  } else if (route.path == '/accesorios' ) {
      mensaje = 'Hola, quisiera revisar accesorios...';
  } else if (route.path === `/${NEGOCIOS.REVISIONTECNICA}`) {
      mensaje = 'Hola, quisiera gestionar mi revisión técnica...';
  } else {mensaje = 'Hola, quisiera resolver una duda...'}
  
  const url = `https://api.whatsapp.com/send/?phone=${numero_whatsapp}&text=${encodeURIComponent(mensaje)}&type=phone_number&app_absent=0`
  window.open(url, '_blank')
}

onMounted(() => {
  debug.log("modo_sistema.value: ", modo_sistema.value);

  configurarInput(inputUbicacionRef.value);
  funcion_de_inicio(); //este se queda para evitar error en lado de servidor.
});

// Mantiene el texto del input igual a la ubicación guardada
watch(ubication, (nuevaUbicacion) => {
  if (nuevaUbicacion?.isLoading || !inputUbicacionRef.value) return;
  inputUbicacionRef.value.value = nuevaUbicacion?.address || "";
});

// Sin código duplicado - solo usar la función importada
watch(
  [() => route.path, () => modo_sistema.value],
  ([newPath, newModo], [oldPath, oldModo]) => {
    if (newPath === oldPath && newModo === oldModo) return;
    
    debug.log("debug -> [COMPONENTE] Cambio detectado:", { newPath, newModo });
    
    if (verificarSincronizacion(newPath, newModo)) {
      debug.log("debug -> [COMPONENTE] Sincronizado - Ejecutando funcion_de_inicio");
      funcion_de_inicio();
    } else {
      debug.log("debug -> [COMPONENTE] ❌ Discrepancia - Esperando sincronización");
    }
  },
  { immediate: false }
);

</script>

<style scoped>
.borde_especial {
  border-color: #388A1C;
}
</style>